if (!customElements.get('announcement-bar')) {
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.isPlaying = true;
      this.button = this.querySelector('[data-button]');
      this.speed = Number(this.dataset.speed);
      this.transition = Number(this.dataset.transition);
      this.items = this.querySelectorAll('.announcement-bar__item');
      
      // Bind methods
      this.updateHeight = this.updateHeight.bind(this);
      this.reinitSwiper = this.reinitSwiper.bind(this);
    }

    connectedCallback() {
      this.initSwiper();
      this.updateHeight();

      // Add resize listener with debounce
      window.addEventListener('resize', this.debounce(this.reinitSwiper, 250));
    }

    reinitSwiper() {
      // Destroy existing swiper instance
      if (this.swiper) {
        this.swiper.destroy(true, true);
      }
      
      // Update heights
      this.updateHeight();
      
      // Reinitialize swiper
      this.initSwiper();
    }

    updateHeight() {
      // Reset heights first
      this.items.forEach(item => {
        item.style.height = 'auto';
      });

      // Get the maximum height
      let maxHeight = 0;
      this.items.forEach(item => {
        const height = item.offsetHeight;
        maxHeight = Math.max(maxHeight, height);
      });

      // Set all items to the maximum height
      if (maxHeight > 0) {
        this.items.forEach(item => {
          item.style.height = `${maxHeight}px`;
        });
      }
    }

    debounce(fn, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          fn(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }

    initSwiper() {
      const swiperEl = this.querySelector('.swiper');
      if (!swiperEl) return;

      this.swiper = new Swiper(swiperEl, {
        effect: 'creative',
        creativeEffect: {
          prev: {
            translate: [0, 0, 0],
            opacity: 0,
          },
          next: {
            translate: [0, 0, 0],
            opacity: 0,
          },
          current: {
            translate: [0, 0, 0],
            opacity: 1,
          },
        },
        loop: true,
        autoplay: {
          delay: this.speed,
          disableOnInteraction: false,
        },
        speed: this.transition,
        on: {
          init: () => {
            this.updateHeight();
          },
          slideChange: () => {
            this.updateHeight();
          }
        }
      });
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);
}
